import memoizeOne from 'memoize-one';
import { useContext, useEffect } from 'react';

import { StylingContext, StylingContextState } from 'context/Styling';


const memoizedStyleCreators = new WeakMap();

export function useStyles<T>(
  getStyles: (styling: StylingContextState, ...additionalParams: any[]) => T,
  ...additionalParams: any[]
): T {
  const stylingContextState = useContext(StylingContext);

  let memoizedStyleCreator = memoizedStyleCreators.get(getStyles) as typeof getStyles;

  if (!memoizedStyleCreator) {
    memoizedStyleCreator = memoizeOne(getStyles);
    memoizedStyleCreators.set(getStyles, memoizedStyleCreator);
  }

  useEffect(() => {
    return () => {
      memoizedStyleCreators.delete(getStyles);
    };
  }, [getStyles]);

  return memoizedStyleCreator(stylingContextState, ...additionalParams);
}
